var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.667 9.333h-5.834A.833.833 0 0 1 20 8.5V2.667H7.917a1.247 1.247 0 0 0-1.25 1.243v24.173a1.247 1.247 0 0 0 1.243 1.25h17.507a1.247 1.247 0 0 0 1.25-1.243V9.333zm-5 12.709c0 .345-.28.625-.625.625h-8.75a.625.625 0 0 1-.625-.625v-.417c0-.345.28-.625.625-.625h8.75c.345 0 .625.28.625.625v.417zm0-3.334c0 .346-.28.625-.625.625h-8.75a.625.625 0 0 1-.625-.625v-.416c0-.346.28-.625.625-.625h8.75c.345 0 .625.28.625.625v.416zm0-3.333c0 .345-.28.625-.625.625h-8.75a.625.625 0 0 1-.625-.625v-.417c0-.345.28-.625.625-.625h8.75c.345 0 .625.28.625.625v.417z",
    opacity: 0.161
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.302 8.135-5.099-5.104a1.25 1.25 0 0 0-.885-.364H20V8.5c0 .46.373.833.833.833h5.834v-.317c0-.33-.131-.647-.365-.88zM21.042 21h-8.75a.625.625 0 0 0-.625.625v.417c0 .345.28.625.625.625h8.75c.345 0 .625-.28.625-.625v-.417a.625.625 0 0 0-.625-.625zm0-3.333h-8.75a.625.625 0 0 0-.625.625v.416c0 .346.28.625.625.625h8.75c.345 0 .625-.28.625-.625v-.416a.625.625 0 0 0-.625-.625zm0-3.334h-8.75a.625.625 0 0 0-.625.625v.417c0 .345.28.625.625.625h8.75c.345 0 .625-.28.625-.625v-.417a.625.625 0 0 0-.625-.625z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulFile);
export default __webpack_public_path__ + "static/media/icons-colorful-file.7382f0ca.svg";
export { ForwardRef as ReactComponent };